import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import { AdProviders, adunitMemo, ADUNIT_MAP } from '../constants';
import { useAdUnit } from '../useAdUnit';
const MobileDevPageDisplaySide300x250 = /*#__PURE__*/ React.memo(({ safety ='unlikely'  })=>{
    const slotAttr = useAdUnit(AdProviders.Nitro, ADUNIT_MAP['MobileDevPageDisplaySide300x250'], safety, {
        refreshLimit: 30,
        refreshTime: 30,
        renderVisibleOnly: false,
        refreshVisibleOnly: true,
        sizes: [
            [
                '300',
                '250'
            ]
        ],
        report: {
            enabled: false
        }
    });
    return /*#__PURE__*/ React.createElement("div", _extends({}, slotAttr));
}, adunitMemo);
MobileDevPageDisplaySide300x250.displayName = 'MobileDevPageDisplaySide300x250';
export default MobileDevPageDisplaySide300x250;
